module.exports = __webpack_public_path__ + "static/media/contact2b36939d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/contact.svg
// module id = 1474
// module chunks = 0